import React, { useEffect, useState, forwardRef, ForwardedRef } from "react";
import { Input } from "@/components/ui/input";

interface MaskedMobileInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string; // controlled value
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void; // controlled onChange
}

const MaskedMobileInput = forwardRef(
  (
    { value, onChange, onBlur, ...rest }: MaskedMobileInputProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const [displayValue, setDisplayValue] = useState(value ?? "");
    const [isMasked, setIsMasked] = useState(false);

    // Sync displayValue when parent changes value
    useEffect(() => {
      if (!isMasked) {
        setDisplayValue(value ?? "");
      }
        
      if (!value) {
        setDisplayValue("");
      }
    }, [value, isMasked]);
    

    // Handle input change
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value.replace(/\D/g, "").slice(0, 10); // max 10 digits
      setDisplayValue(raw);
      setIsMasked(false);

      // Call parent's onChange with raw value
      onChange?.({
        ...e,
        target: { ...e.target, value: raw },
      } as React.ChangeEvent<HTMLInputElement>);
    };

    // Handle blur to mask value
    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      if (displayValue) {
        const masked = `${"*".repeat(Math.max(0, displayValue.length - 4))}${displayValue.slice(-4)}`;
        setDisplayValue(masked);
        setIsMasked(true);
      }
      onBlur?.(e); // forward onBlur
    };

    // Unmask on focus
    const handleFocus = () => {
      setDisplayValue(value ?? "");
      setIsMasked(false);
    };

    return (
      <Input
        ref={ref}
        placeholder="Enter registered mobile number"
        value={displayValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        maxLength={10}
        inputMode="numeric"
        autoComplete="off"
        {...rest} // forward other props naturally
      />
    );
  }
);

export default MaskedMobileInput;
